module.exports = __webpack_public_path__ + "static/1-ada896d5529dcf221927b437fa876a1f.png";